export const CLEAR_STATE = 'CLEAR_STATE'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/store/enhancers/clearStateEnhance/actionTypes.ts